var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 846,
    height: 1064,
    viewBox: "0 0 846 1064",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_63037)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.3936,
    y: 217.18,
    width: 283.151,
    height: 996.545,
    rx: 141.576,
    transform: "rotate(-49.9455 44.3936 217.18)",
    fill: "url(#paint0_linear_52_63037)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -28.8766,
    y: 635.219,
    width: 254.561,
    height: 789.13,
    rx: 127.28,
    transform: "rotate(-49.9455 -28.8766 635.219)",
    stroke: "url(#paint1_linear_52_63037)",
    strokeWidth: 14
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_63037",
    x1: 185.969,
    y1: 217.18,
    x2: 185.969,
    y2: 1213.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_63037",
    x1: 95.5412,
    y1: 636.072,
    x2: 95.5412,
    y2: 1439.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_63037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 846,
    height: 1064,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBgIcon);
export default __webpack_public_path__ + "static/media/mainBg_icon.51e1ae0f.svg";
export { ForwardRef as ReactComponent };